import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import RedButton from 'components/buttons/RedButton';
import { H4 } from 'components/typography/Headers';
import { Text1 } from 'components/typography/Texts';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 36px;
`;

const Button = styled(RedButton)`
  height: 46px;
  margin-top: 12px;
`;

interface Props {
  onCreateCampaign: () => void;
}

const SuccessPopup = ({ onCreateCampaign }: Props) => {
  const { t } = useTranslation('myProfile');

  return (
    <Container data-testid={'become-fundraiser-success-popup'}>
      <H4 data-testid={'header'}>{t('become-fundraiser.success-popup.header')}</H4>
      <Text1 data-testid={'description'}>{t('become-fundraiser.success-popup.description')}</Text1>
      <Button onClick={onCreateCampaign}>{t('become-fundraiser.success-popup.button')}</Button>
    </Container>
  );
};

export default SuccessPopup;
